import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import { t } from "i18n/i18n";
import { SquareButton, type SquareButtonProps } from "mds/components/buttons/SquareButton";
import { AmplitudeEventPropertiesType } from "utils/amplitude";

type CancelSaveWidgetProps = {
  className?: string;
  onClickCancel?: () => void;
  onClickSave?: () => void;
  size?: SquareButtonProps["size"];
  isSaveDisabled?: boolean;
  saveTextKey?: "save" | "copy" | "move" | "import_section" | "update";
  saveEventName?: string;
  saveEventProps?: Omit<AmplitudeEventPropertiesType, "eventCategory">;
};

export const CancelSaveWidget: FC<CancelSaveWidgetProps> = ({
  onClickCancel,
  onClickSave,
  className,
  isSaveDisabled = false,
  size = "s",
  saveTextKey = "save",
  saveEventName,
  saveEventProps,
}) => {
  return (
    <div className={twMerge("flex gap-2 self-center", className)}>
      {onClickCancel && (
        <SquareButton
          isSelected={false}
          kind="tertiary"
          size={size}
          title={t("common.cancel")}
          onClick={onClickCancel}
        >
          {t("common.cancel")}
        </SquareButton>
      )}
      {onClickSave && (
        <SquareButton
          disabled={isSaveDisabled}
          eventName={saveEventName}
          eventProps={saveEventProps}
          isSelected={false}
          kind="accent"
          size={size}
          title={t(`common.${saveTextKey}`)}
          onClick={onClickSave}
        >
          {t(`common.${saveTextKey}`)}
        </SquareButton>
      )}
    </div>
  );
};
